import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PortfolioSection from "@/components/home/PortfolioSection";
import { Eyebrow } from "@/components/lux";

export default function WorkPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-[#090A0F] min-h-screen">
      <Header />
      <main className="pt-28 sm:pt-32">
        <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
          <Eyebrow>The Work</Eyebrow>
          <h1 className="font-display font-bold text-white text-4xl sm:text-6xl mt-3">Portfolio</h1>
        </div>
        <PortfolioSection />
      </main>
      <Footer />
    </div>
  );
}
